import * as React from "react";
import { forwardRef } from "react";
const SvgActiveUserIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 11, viewBox: "0 0 11 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 5.5, cy: 5.25, r: 4.5, fill: "#14B8A6", stroke: "white", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgActiveUserIcon);
export default ForwardRef;
